import React, { useState } from 'react';
import MapView from './MapView';
import InfoSection from './InfoSection';
import LandmarkModal from './LandmarkModal';
import PageHero from './PageHero';
import { Landmark } from '../types';
import { landmarks, islandInfo } from '../data/landmarks';
import './MapPage.css';

const MapPage: React.FC = () => {
  const [selectedLandmark, setSelectedLandmark] = useState<Landmark | null>(null);

  const handleLandmarkClick = (landmark: Landmark) => {
    setSelectedLandmark(landmark);
  };

  const handleCloseModal = () => {
    setSelectedLandmark(null);
  };

  return (
    <div className="map-page">
      <PageHero 
        title="Plan Your Trip"
        subtitle="Explore the Abrolhos Islands"
      />

      <div className="map-page-content-wrapper">
        <div className="map-page-content">
          <div className="trip-intro">
            <InfoSection islandInfo={islandInfo} />
          </div>
          
          <MapView 
            landmarks={landmarks}
            onLandmarkClick={handleLandmarkClick}
          />

          <div className="trip-provisions">
            <section className="trip-card trip-card--no-ticks">
              <h3 className="info-section-header">WHAT WE PROVIDE</h3>
              <ul>
                <li>
                  <strong>Electricity:</strong> Generator power is available daily from 6:30am to 9:30pm.
                </li>
                <li>
                  <strong>Internet:</strong> Starlink Wi-Fi is available during generator operating hours.
                </li>
                <li>
                  <strong>Water:</strong> Fresh rainwater is provided for drinking and washing.
                </li>
                <li>
                  <strong>Essentials:</strong> We supply toilet paper and basic household supplies.
                </li>
              </ul>
            </section>

            <section className="trip-card trip-card--no-ticks">
              <h3 className="info-section-header">WHAT WE DON'T PROVIDE</h3>
              <ul>
                <li>
                  <strong>Transport:</strong> Guests must arrange their own private vessel transit (35nm offshore).</li>
                <li>
                  <strong>Provisions:</strong> No food, drinks, or retail services are available. You must be fully self-catered.</li>
                <li>
                  <strong>Tours:</strong> There are no guided tours or commercial activities; exploration is self-guided.</li>
                <li>
                  <strong>Overnight Power:</strong> There is no electricity available between 9:30pm and 6:30am.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>

      {selectedLandmark && (
        <LandmarkModal
          landmark={selectedLandmark}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default MapPage;

